import feture1 from "../../images/feature-1.png";
import client1 from "../../images/client-1.png";
import feture2 from "../../images/feature-2.png";
import client2 from "../../images/client-2.png";
import feture3 from "../../images/feature-3.png";
import client3 from "../../images/client-3.png";
import feture4 from "../../images/feature-4.png";
import feture5 from "../../images/feature-5.png";

import { FaStar } from "react-icons/fa";


export const CourseData = [
    {
        id : 1,
        courseTitle : "The Business Intelligence Analyst Course",
        courseImg : feture1,
        price : "$40.00",
        courseType : "Managment",
        rating : <FaStar/>,
        authorImg : client1,
        authorTitle : "Prof.",
        authodName : "Shawn Adward"
    },
    {
        id : 2,
        courseTitle : "German language Learning Course",
        courseImg : feture2,
        price : "$50.00",
        courseType : "Language",
        rating : <FaStar/>,
        authorImg : client2,
        authorTitle : "Prof.",
        authodName : "Hitesh Adward"
    },
    {
        id : 3,
        courseTitle : "Complete Advance Architecture Study",
        courseImg : feture3,
        price : "$80.00",
        courseType : "Architecture",
        rating : <FaStar/>,
        authorImg : client3,
        authorTitle : " Dr.",
        authodName : "Julia heart"
    },
    {
        id : 4,
        courseTitle : "Intelligence Studies & International History",
        courseImg : feture4,
        price : "$20.00",
        courseType : "History",
        rating : <FaStar/>,
        authorImg : client3,
        authorTitle : "Prof.",
        authodName : "Shawn Adward"
    },
    {
        id : 5,
        courseTitle : "MScEcon International Finance (Specialist/Research)",
        courseImg : feture5,
        price : "$100.00",
        courseType : "Research",
        rating : <FaStar/>,
        authorImg : client2,
        authorTitle : "Dr.",
        authodName : "Julia heart"
    },
    {
        id : 6,
        courseTitle : "The Business Intelligence Analyst Course",
        courseImg : feture1,
        price : "$40.00",
        courseType : "Managment",
        rating : <FaStar/>,
        authorImg : client1,
        authorTitle : "Prof.",
        authodName : "Shawn Adward"
    },
    {
        id : 7,
        courseTitle : "The Business Intelligence Analyst Course",
        courseImg : feture1,
        price : "$40.00",
        courseType : "Managment",
        rating : <FaStar/>,
        authorImg : client1,
        authorTitle : "Prof.",
        authodName : "Shawn Adward"
    },
    {
        id : 8,
        courseTitle : "The Business Intelligence Analyst Course",
        courseImg : feture1,
        price : "$40.00",
        courseType : "Managment",
        rating : <FaStar/>,
        authorImg : client1,
        authorTitle : "Prof.",
        authodName : "Shawn Adward"
    },
    {
        id : 9,
        courseTitle : "German language Learning Course",
        courseImg : feture2,
        price : "$50.00",
        courseType : "Language",
        rating : <FaStar/>,
        authorImg : client2,
        authorTitle : "Prof.",
        authodName : "Hitesh Adward"
    },
    {
        iid : 10,
        courseTitle : "Complete Advance Architecture Study",
        courseImg : feture3,
        price : "$80.00",
        courseType : "Architecture",
        rating : <FaStar/>,
        authorImg : client3,
        authorTitle : " Dr.",
        authodName : "Julia heart"
    },
    {
        id : 11,
        courseTitle : "Intelligence Studies & International History",
        courseImg : feture4,
        price : "$20.00",
        courseType : "History",
        rating : <FaStar/>,
        authorImg : client3,
        authorTitle : "Prof.",
        authodName : "Shawn Adward"
    },
    {
        id : 12,
        courseTitle : "MScEcon International Finance (Specialist/Research)",
        courseImg : feture5,
        price : "$100.00",
        courseType : "Research",
        rating : <FaStar/>,
        authorImg : client2,
        authorTitle : "Dr.",
        authodName : "Julia heart"
    },
]